import React from 'react'

const Loaners = () => {
  return (
    <div>
      Loaners
    </div>
  )
}

export default Loaners
